import React from "react";
import {
    SimpleGrid,Stack,Box,Heading,Text
} from "@chakra-ui/react";

export const InputRowGrid = ({ heading, text, input }) => (
    <SimpleGrid column={{ base: 1, md: 2, lg: 2 }} lineHeight={"normal"}>
      <Stack flexDirection={{ base: "column", md: "row" }}>
        <Box w={{ base: "100%", md: "25%" }}>
          <Heading
            fontWeight={"semibold"}
            mt={"10px"}
            fontSize={{ base: "20px", lg: "26px" }}
            textAlign={{ base: "", md: "start" }}
          >
            {heading}
          </Heading>
        </Box>
        <Box w={{ base: "100%", md: "75%" }}>
          <Text
            fontSize={{ base: "x-small", md: "sm" }}
            display={"flex"}
            justifySelf={"flex-start"}
            lineHeight={{ base: "22px", md: "32px" }}
          >
            {text}
          </Text>
  
          {input}
        </Box>
      </Stack>
    </SimpleGrid>
  );
  